export default "__VITE_ASSET__vGl2yknd__"